/**
 * @generated SignedSource<<0e62db1f5bcf97ca9fdbe3195cbccab8>>
 * @relayHash 9d3481abfa73ea7491e4da03059d184f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f615c576aab94006b7d9fa76c3b16020334411192551638d25b1273d6f6e2cb2

import { ConcreteRequest } from 'relay-runtime';
export type MemberRole = "ADMIN" | "MEMBER" | "OWNER";
export type teamsTeamGraphsPageQuery$variables = {
  account: string;
  team: string;
};
export type teamsTeamGraphsPageQuery$data = {
  readonly accountBySlug: {
    readonly __typename: string;
    readonly id: string;
    readonly members?: {
      readonly nodes: ReadonlyArray<{
        readonly role: MemberRole;
        readonly user: {
          readonly id: string;
        };
      }>;
    };
  } | null | undefined;
  readonly teamBySlug: {
    readonly id: string;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  } | null | undefined;
};
export type teamsTeamGraphsPageQuery = {
  response: teamsTeamGraphsPageQuery$data;
  variables: teamsTeamGraphsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "team"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "organizationSlug",
      "variableName": "account"
    },
    {
      "kind": "Variable",
      "name": "slug",
      "variableName": "team"
    }
  ],
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teamBySlug",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "teamsTeamGraphsPageQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "teamsTeamGraphsPageQuery",
    "selections": [
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberConnection",
                "kind": "LinkedField",
                "name": "members",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9d3481abfa73ea7491e4da03059d184f",
    "id": "f615c576aab94006b7d9fa76c3b16020334411192551638d25b1273d6f6e2cb2",
    "metadata": {},
    "name": "teamsTeamGraphsPageQuery",
    "operationKind": "query",
    "text": "query teamsTeamGraphsPageQuery(\n  $account: String!\n  $team: String!\n) {\n  viewer {\n    id\n  }\n  teamBySlug(organizationSlug: $account, slug: $team) {\n    id\n  }\n  accountBySlug(slug: $account) {\n    id\n    __typename\n    ... on Organization {\n      members {\n        nodes {\n          user {\n            id\n          }\n          role\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "99bc4756ffa182cf5f2db5d5dc50d9d2";

export default node;
